import { useTransactionFlow } from "../../hooks/useTransactionFlow";
import TransactionHeader from "../../components/Transaction/TransactionHeader";
import CustomerSearchStep from "../../components/Transaction/CustomerSearchStep";
import TransactionReviewStep from "../../components/Transaction/TransactionReviewStep";
import TransactionSummaryStep from "../../components/Transaction/TransactionSummaryStep";
import TransactionProgress from "../../components/Transaction/TransactionProgress";
import TransactionConfirmModal from "../../components/Transaction/TransactionConfirmModal";
import NewTransactionButton from "../../components/Transaction/NewTransactionButton";
import { useSelector } from "react-redux";

export default function TransactionInitiate() {
  const { user } = useSelector((state) => state.auth);
  const {
    step,
    formData,
    currentTransaction,
    transactionSummary,
    customer,
    loading,
    summaryLoading,
    customerLoading,
    customerError,
    showConfirmModal,
    showSuccessModal,
    setFormData,
    handleCustomerSearch,
    handleInitiateTransaction,
    handleCreateTransaction,
    handleFulfill,
    handleCancel,
    handleReset,
    setShowConfirmModal,
    setShowSuccessModal
  } = useTransactionFlow();

  const isBusinessUser = user?.role === "business";

  return (
    <div className="min-h-screen">
      {/* Single Column Layout - No Sidebar */}
      <div className="p-4 md:p-6 overflow-y-auto">
        <div className="max-w-4xl mx-auto space-y-6">
          <TransactionHeader 
            currentTransaction={currentTransaction}
            onReset={handleReset}
          />

          <CustomerSearchStep
            step={step}
            formData={formData}
            customer={customer}
            customerLoading={customerLoading}
            customerError={customerError}
            loading={loading}
            onFormChange={setFormData}
            onSubmit={handleCustomerSearch}
            onAmountSubmit={handleInitiateTransaction}
          />

          {/* Show summary step for business users when transaction is completed */}
          {isBusinessUser && step === 3 && (
            <TransactionSummaryStep
              step={step}
              transactionSummary={transactionSummary}
              summaryLoading={summaryLoading}
              onReset={handleReset}
            />
          )}

          {/* Admin flow components - only show for admin users */}
          {!isBusinessUser && (
            <>
              <TransactionReviewStep
                step={step}
                currentTransaction={currentTransaction}
                loading={loading}
                onFulfill={handleFulfill}
                onCancel={handleCancel}
              />

              <TransactionSummaryStep
                step={step}
                transactionSummary={transactionSummary}
                summaryLoading={summaryLoading}
                onReset={handleReset}
              />

              <TransactionProgress
                step={step}
                currentTransaction={currentTransaction}
              />
            </>
          )}

          <NewTransactionButton
            currentTransaction={currentTransaction || transactionSummary}
            step={step}
            onReset={handleReset}
          />

          {/* Business flow modals - only for business users */}
          {isBusinessUser && (
            <>
              <TransactionConfirmModal
                open={showConfirmModal}
                onOpenChange={setShowConfirmModal}
                customer={customer}
                formData={formData}
                onConfirm={handleCreateTransaction}
                loading={loading}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
